import React, { useEffect, useState } from "react"
import { initializeApp } from "firebase/app"
import { getFirestore, collection, getDocs, addDoc } from "firebase/firestore"
import jsPDF from "jspdf"
import "./styles/booking.css"

const firebaseConfig = {
  apiKey: "AIzaSyDO-ivCiTJcGRD4ZQVxEefflp8dXigy_Fo",
  authDomain: "hellocar-777.firebaseapp.com",
  projectId: "hellocar-777",
  storageBucket: "hellocar-777.appspot.com",
}

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)

const weekdaySlots = ["10:00 AM", "12:00 PM", "02:00 PM", "04:00 PM", "06:00 PM"]
const weekendSlots = ["10:00 AM", "12:00 PM"]


export default function Booking() {
  const [bookedSlots, setBookedSlots] = useState([])
  const [selectedDate, setSelectedDate] = useState("")
  const [availableTimes, setAvailableTimes] = useState([])
  const [offerMessage, setOfferMessage] = useState("")
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    car: "",
    need: "",
    time: "",
  })
  const [message, setMessage] = useState("")
  const [bookingDetails, setBookingDetails] = useState(null)

  const fetchBookedSlots = async () => {
    const querySnapshot = await getDocs(collection(db, "helloCarAppointments"))
    const data = querySnapshot.docs.map(doc => doc.data())
    setBookedSlots(data)
  }

  useEffect(() => {
    fetchBookedSlots()
  }, [])

  // Determine offers
  const determineOffers = (dateObj, time) => {
    const isWeekend = dateObj.getDay() === 6 || dateObj.getDay() === 0
    const isMorningSlot = ["10:00 AM", "12:00 PM"].includes(time)
    let applicable = []

    if (!isWeekend && isMorningSlot)
      applicable.push("🎁 Morning Saver: 15% off all car accessories!")

    if (!isWeekend)
      applicable.push("🧠 Weekday Quiz Bonus: Earn 10% off accessories!")

    return applicable
  }

  // Update available slots + offer message
useEffect(() => {
  if (selectedDate) {
    const jsDate = new Date(selectedDate)
    const isWeekend = jsDate.getDay() === 6 || jsDate.getDay() === 0
    const slotTimes = isWeekend ? weekendSlots : weekdaySlots
    const readableDate = jsDate.toLocaleDateString("en-IN")

    const bookedForDate = bookedSlots
      .filter(slot => slot.date === readableDate && slot.isPaid === true)
      .map(slot => slot.time)

    const freeTimes = slotTimes.filter(time => !bookedForDate.includes(time))
    setAvailableTimes(freeTimes)

    const msg = isWeekend
      ? "🎉 Weekends: Only 10AM–12PM & 12PM–2PM available. Rest are walk-in."
      : "💡 Weekday Bonus: Booking unlocks special offers!"

    setOfferMessage(msg)
  }
}, [selectedDate, bookedSlots])


  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!selectedDate || !formData.time) {
      setMessage("⚠️ Please select a date and time before booking.")
      return
    }

    const jsDate = new Date(selectedDate)
    const readableDate = jsDate.toLocaleDateString("en-IN")
    const applicableOffers = determineOffers(jsDate, formData.time)

    const cleanData = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      phone: formData.phone.trim(),
      car: formData.car.trim(),
      need: formData.need.trim(),
      date: readableDate,
      time: formData.time,
      offers: applicableOffers,
      offer: applicableOffers, // safe duplicate field
      isPaid: false,
      createdAt: new Date().toISOString(),
    }

    try {
      const docRef = await addDoc(collection(db, "helloCarAppointments"), cleanData)
      const bookingId = docRef.id
      setBookingDetails({ ...cleanData, bookingId })
      setMessage("")

      await fetch("https://formspree.io/f/xyyrqagb", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subject: `📅 New Booking – ID: ${bookingId}`,
          message: `
New Booking Details:

Name: ${cleanData.name}
Email: ${cleanData.email}
Phone: ${cleanData.phone}
Car: ${cleanData.car}
Service: ${cleanData.need}
Date: ${cleanData.date}
Time: ${cleanData.time}

Offers Applied:
${applicableOffers.map(o => `• ${o}`).join("\n")}

Booking ID: ${bookingId}
          `,
        }),
      })
    } catch (err) {
      console.error("🔥 Firestore error:", err)
      setMessage("❌ Error booking appointment. Please try again.")
    }
  }

  const handleDownloadPDF = () => {
    const doc = new jsPDF()
    const b = bookingDetails

    doc.setFontSize(18)
    doc.text("HelloCar Booking Receipt", 20, 20)
    doc.setFontSize(12)

    doc.text(`Booking ID: ${b.bookingId}`, 20, 35)
    doc.text(`Name: ${b.name}`, 20, 45)
    doc.text(`Email: ${b.email}`, 20, 55)
    doc.text(`Phone: ${b.phone}`, 20, 65)
    doc.text(`Car: ${b.car}`, 20, 75)
    doc.text(`Service: ${b.need}`, 20, 85)
    doc.text(`Date: ${b.date}`, 20, 95)
    doc.text(`Time: ${b.time}`, 20, 105)
    doc.text("Booking Fee: ₹250", 20, 115)
    doc.text("Payment Link: https://rzp.io/l/HelloCar250", 20, 125)

    if (b.offers && b.offers.length) {
      doc.text("Offers Applied:", 20, 140)
      b.offers.forEach((offer, idx) =>
        doc.text(`- ${offer}`, 25, 150 + idx * 8)
      )
    }

    doc.save(`HelloCar_Booking_${b.bookingId}.pdf`)
  }

  const businessWhatsApp = "+919899208565"
  const waText = bookingDetails
    ? encodeURIComponent(
        `Hello HelloCar! I've booked a slot.\nBooking ID: ${bookingDetails.bookingId}\nDate: ${bookingDetails.date}\nTime: ${bookingDetails.time}\nOffers: ${bookingDetails.offers.join(
          ", "
        )}\nI've paid ₹250 — attaching payment proof now.`
      )
    : ""

  const waLink = `https://wa.me/${businessWhatsApp.replace("+", "")}?text=${waText}`

  return (
    <div className="booking-page">
      {!bookingDetails ? (
        <form className="booking-form" onSubmit={handleSubmit}>
          <h1 className="booking-title">Book An Appointment for Your Car</h1>

          <p className="booking-note">
            <b>
              Choose your preferred date and time slot — ₹250 advance confirms your booking.
              <p className="scheme">
                <br />Our Scheme :
                <br />Get 10% off on weekdays.
                <br />Get 15% off on weekday 10AM or 12PM bookings.
              </p>
            </b>
          </p>

          <input
            type="date"
            value={selectedDate}
            onChange={e => {
              const picked = new Date(e.target.value)
              const today = new Date()
              const maxDate = new Date()
              maxDate.setDate(today.getDate() + 7)

              if (picked > maxDate) {
                setMessage("⚠️ You can only book appointments for the next 7 days.")
                setSelectedDate("")
                return
              }

              setMessage("")
              setSelectedDate(e.target.value)
            }}
            min={new Date().toISOString().split("T")[0]}
            max={new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
              .toISOString()
              .split("T")[0]}
            required
          />

          {offerMessage && <p className="offer-message">{offerMessage}</p>}

          <select
            name="time"
            value={formData.time}
            onChange={handleChange}
            disabled={!selectedDate}
            required
          >
            <option value="">Select Time</option>
            {availableTimes.length > 0 ? (
              availableTimes.map(time => (
                <option key={time} value={time}>
                  {time}
                </option>
              ))
            ) : (
              <option disabled>No Slots Available</option>
            )}
          </select>

          <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
          <input type="text" name="phone" placeholder="Phone Number (+91)" value={formData.phone} onChange={handleChange} required />
          <input type="text" name="car" placeholder="Car Model" value={formData.car} onChange={handleChange} required />
          <input type="text" name="need" placeholder="Service Required" value={formData.need} onChange={handleChange} required />

          <button type="submit" className="book-btn">Confirm Booking</button>
        </form>
      ) : (
        <div className="booking-confirmation">
          <h2>✅ Booking Confirmed!</h2>

          <p><b>Booking ID:</b> {bookingDetails.bookingId}</p>
          <p><b>Name:</b> {bookingDetails.name}</p>
          <p><b>Email:</b> {bookingDetails.email}</p>
          <p><b>Phone:</b> {bookingDetails.phone}</p>
          <p><b>Car:</b> {bookingDetails.car}</p>
          <p><b>Service:</b> {bookingDetails.need}</p>
          <p><b>Date:</b> {bookingDetails.date}</p>
          <p><b>Time:</b> {bookingDetails.time}</p>

          <p><b>Fee:</b> ₹250</p>

          <p>
            <b>Payment Link:</b>{" "}
            <a href="https://rzp.io/l/HelloCar250" target="_blank" rel="noreferrer" className="pay-btn">
              https://rzp.io/l/HelloCar250
            </a>
          </p>

          <p>
            <b>
              Please share your payment screenshot on WhatsApp.<br />
              Use the button below.
            </b>
          </p>

          <a href={waLink} target="_blank" rel="noreferrer" className="wa-btn">
            📤 Send Proof via WhatsApp
          </a>

          <button onClick={handleDownloadPDF} className="book-btn">
            📄 Download Booking Receipt (PDF)
          </button>

          {bookingDetails.offers.length > 0 && (
            <div className="discount-msg">
              <p><b>Offers Unlocked:</b></p>
              <ul>
                {bookingDetails.offers.map((offer, i) => (
                  <li key={i}>{offer}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {message && <p className="booking-message">{message}</p>}
    </div>
  )
}
